// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__3pp5L","container":"Main_container__2YPem"};